<template>
	<div>
		<v-simple-table>
			<template v-slot:default>
				<thead>
					<tr style="width: 100%; height: 48px; color: #192A3E; background: #EAEAEA;">
						<th style="text-align: left; " v-for=" header in header_local" :key="header.value">
							{{ header.text }}
						</th>
					</tr>
				</thead>
				<tbody>
					<tr style="width: 100%; height: 64px; " v-for="item in filterResults" :key="item.id">
						<td style="border-bottom: thin solid #FAFAFA; text-align: left;" v-for=" header in header_local" :key="`${header.value}_${item.id}`">{{ item[`${header.value}`] }}</td>
					</tr>
				</tbody>
			</template>
		</v-simple-table>
	</div>
</template>

<script>
export default {
	name: 'PrintTable',
	props: {
		headers: {
			type: Array,
			default: () => [],
		},
		joblists: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			result: [],
			header_local: this.headers.filter(head => {return head.showable}),
		}
	},
	created() {
		this.result = this.joblists;
	},
	computed: {
		filterResults() {
			const filterRes = [];
			this.result.forEach(res => {
				const obj = {};
				
				this.headers.forEach(item => {
					if (item.showable) {
						let tmp = null;
						if (item.value === 'total_value') {
							const number = this._formatNumber(res['total_value']);
							tmp = `${res['currency'].symbol} ${number}`;
						} else if (item.value === 'total_invoiced') {
							const number = this._formatNumber(res['total_invoiced']);
							tmp = `${res['currency'].symbol} ${number}`
						} else {
							tmp = typeof(res[item.value]) === 'object' ? res[item.value].name : res[item.value];
						}

						obj[item.value] = tmp;	
					}
						
				});
				obj['id'] = res.id;

				filterRes.push(obj);
			})
			return filterRes;
		},
	},
	watch: {
		// when headers changed, the print table changed
		headers: {
			handler() { 
				this.header_local = this.headers.filter(head => {return head.showable});
			},
			deep: true,
		}
	},
	methods: {
		_formatNumber(num) {
			let res = 0;
			if (Number.isInteger(num)) {
				const integer = num.toLocaleString();
				res = integer + '.00';
			} else {
				const num_arr = (num.toString()).split('.');
				const integer = Number(num_arr[0]).toLocaleString();

				if (num_arr.length > 1) {
					if (num_arr[1].length === 1) {
						res = integer + '.' + num_arr[1] + '0';
					} else {
						res = integer + '.' + num_arr[1];
					}
					
				} else {
					res = integer + '.00' ;
				}
			}
			return res;
		},
	},
}
</script>

<style lang="scss" scoped>
</style>